import { render } from "./SvgIcon.vue?vue&type=template&id=feefca6e&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=feefca6e&scoped=true&lang=css"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feefca6e"]])

export default __exports__